import { useEffect } from "react";

/**
 *
 * @param {*} ref
 * @param {*} callback
 * @param {*} listenForClick
 */
export function useOutsideClick(ref, callback, listenForClick) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    if (listenForClick) {
      // add the event listener only when state is "edit"
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      // remove the event listener when state is not "edit"
      if (listenForClick) {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };
  }, [ref, callback, listenForClick]); // add state as a dependency
}
